/* Belonge Redesign — cart drawer + fit finder. No dependencies. */
(function () {
  if (window.__belongeBooted) return;
  window.__belongeBooted = true;
  var money = function (cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };
  var FREE_SHIP = 149900; // paise
  var TIERS = [{ qty: 2, pct: 12 }, { qty: 3, pct: 18 }];
  var PAY_HTML = '<div class="bl-paybadges"><span class="bl-paylabel">Secure checkout</span><span class="bl-payicons">' +
    '<svg viewBox="0 0 30 18"><rect width="30" height="18" fill="#fff"/><text x="15" y="13" font-family="Georgia,serif" font-style="italic" font-weight="700" font-size="9" fill="#1A1F71" text-anchor="middle">VISA</text></svg>' +
    '<svg viewBox="0 0 30 18"><rect width="30" height="18" fill="#fff"/><circle cx="12" cy="9" r="6" fill="#EB001B"/><circle cx="18" cy="9" r="6" fill="#F79E1B" opacity=".9"/></svg>' +
    '<svg viewBox="0 0 30 18"><rect width="30" height="18" fill="#fff"/><text x="15" y="13" font-family="Arial,sans-serif" font-weight="700" font-size="9" fill="#14130F" text-anchor="middle">UPI</text></svg>' +
    '</span></div>';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function readJSON(sel) { var el = $(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var TIGHTS_IDS = readJSON('[data-bl-tights-ids]') || [];
  var XSELL = { tights: readJSON('[data-bl-xsell-tights]') || [], coords: readJSON('[data-bl-xsell-coords]') || [] };

  function tiersMarkup(cart) {
    var tightsQty = cart.items.reduce(function (n, it) { return TIGHTS_IDS.indexOf(it.product_id) > -1 ? n + it.quantity : n; }, 0);
    if (!tightsQty) return '';
    var maxTier = TIERS[TIERS.length - 1];
    var reached = null;
    TIERS.forEach(function (t) { if (tightsQty >= t.qty) reached = t; });
    var segs = '';
    for (var i = 0; i < maxTier.qty; i++) {
      segs += '<i style="flex:1;height:3px;background:' + (i < tightsQty ? 'var(--accent)' : 'var(--line)') + '"></i>';
    }
    var msg;
    if (reached && reached.qty === maxTier.qty) {
      msg = 'Set discount unlocked — <b>' + reached.pct + '% off</b> your tights';
    } else {
      var next = TIERS.filter(function (t) { return t.qty > tightsQty; })[0];
      var remain = next.qty - tightsQty;
      msg = reached
        ? 'Add ' + remain + ' more tight' + (remain > 1 ? 's' : '') + ' for <b>' + next.pct + '% off</b> (' + reached.pct + '% off unlocked)'
        : 'Add ' + remain + ' more tight' + (remain > 1 ? 's' : '') + ' to unlock <b>' + next.pct + '% off</b>';
    }
    return '<div class="bl-tiers"><div class="bl-tiers__msg">' + msg + '</div><div class="bl-tiers__bar">' + segs + '</div></div>';
  }

  function selectedSize(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var opts = it.options_with_values || [];
      for (var j = 0; j < opts.length; j++) {
        if (/size/i.test(opts[j].name)) return opts[j].value;
      }
    }
    return null;
  }

  function pickVariant(p, size) {
    var vs = p.variants || [];
    if (!vs.length) return null;
    if (!size) return vs[0];
    var idx = (p.optionNames || []).findIndex(function (n) { return /size/i.test(n); });
    if (idx < 0) return vs[0];
    var match = vs.filter(function (v) { return v.options[idx] === size; });
    return match.length ? match[0] : null;
  }

  function xsellMarkup(cart) {
    var inCart = cart.items.map(function (it) { return it.product_id; });
    var hasTights = cart.items.some(function (it) { return TIGHTS_IDS.indexOf(it.product_id) > -1; });
    var size = selectedSize(cart);
    function resolve(list) {
      return list
        .filter(function (p) { return inCart.indexOf(p.id) === -1; })
        .map(function (p) { return { p: p, v: pickVariant(p, size) }; })
        .filter(function (r) { return r.v; });
    }
    var set = resolve(hasTights ? XSELL.coords : XSELL.tights);
    if (!set.length) set = resolve(hasTights ? XSELL.tights : XSELL.coords);
    set = set.slice(0, 3);
    if (!set.length) return '';
    var cards = set.map(function (r) {
      var p = r.p, v = r.v;
      var img = v.image || p.image;
      return '<div class="bl-xsell__card"><a href="' + p.url + '"><img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="120" height="150"></a>' +
        '<div class="bl-xsell__t"><a href="' + p.url + '">' + p.title + '</a><span>' + money(p.price) + '</span></div>' +
        '<button type="button" class="bl-xsell__add" data-bl-xsell-add="' + v.id + '">Add +</button></div>';
    }).join('');
    return '<div class="bl-xsell"><div class="bl-xsell__head">' + (hasTights ? 'Complete the set' : 'Pairs well') + '</div><div class="bl-xsell__grid">' + cards + '</div></div>';
  }

  /* ---------- cart ---------- */
  var drawer = null;
  function openDrawer() { if (drawer) { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.removeAttribute('open'); document.body.style.overflow = ''; } }

  function renderCart(cart) {
    if (!drawer) return;
    var body = $('[data-bl-cart-body]', drawer);
    var count = cart.item_count;
    $$('[data-bl-bagcount]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
    if (!count) {
      body.innerHTML = '<div class="bl-empty"><div class="bl-serif" style="font-size:30px">Nothing in here yet</div>' +
        '<p>Squat-tested tights, co-ords and tops — free shipping over ₹1,499.</p>' +
        '<button class="bl-btn" data-bl-close>Keep shopping</button></div>';
      return;
    }
    var pct = Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100));
    var note = cart.total_price >= FREE_SHIP ? 'Free shipping unlocked' : money(FREE_SHIP - cart.total_price) + ' away from free shipping';
    var lines = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="bl-line" data-key="' + it.key + '">' +
        '<img src="' + img + '" alt="' + it.product_title.replace(/"/g, '&quot;') + '" loading="lazy" width="78" height="100">' +
        '<div class="bl-line__b">' +
          '<div class="bl-line__t"><span>' + it.product_title + '</span><span>' + money(it.final_line_price) + '</span></div>' +
          (variant ? '<span class="bl-line__v">' + variant + '</span>' : '') +
          '<div class="bl-qty"><button data-bl-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button data-bl-qty="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="bl-line__rm" data-bl-remove aria-label="Remove item">Remove</button>' +
        '</div></div>';
    }).join('');
    body.innerHTML =
      '<div class="bl-ship"><div class="bl-ship__bar"><i style="width:' + pct + '%"></i></div><div class="bl-ship__txt">' + note + '</div></div>' +
      tiersMarkup(cart) +
      '<div class="bl-lines">' + lines + xsellMarkup(cart) + '</div>' +
      '<div class="bl-foot"><div class="bl-foot__row"><span class="bl-eyebrow">Subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="bl-btn" style="width:100%">Checkout</button></form>' +
      PAY_HTML +
      '<div style="text-align:center;font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:#8B8578;margin-top:10px">7-day free exchange · Ships in 48 hours</div></div>';
  }

  function fetchCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); updateCartPageDom(c); if (open) openDrawer(); return c; })
      .catch(function (e) { console.warn('[belonge] cart fetch failed', e); });
  }

  function updateCartPageDom(cart) {
    var page = $('[data-bl-cartpage]');
    if (!page) return;
    if (!cart.item_count) { window.location.reload(); return; }
    $$('[data-bl-page-count]', page).forEach(function (el) { el.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : ''); });
    $$('.bl-li[data-key]', page).forEach(function (row) {
      var it = cart.items.filter(function (x) { return x.key === row.dataset.key; })[0];
      if (!it) { row.parentNode.removeChild(row); return; }
      var qv = row.querySelector('[data-bl-page-qtyval]'); if (qv) qv.textContent = it.quantity;
      var pr = row.querySelector('[data-bl-page-price]'); if (pr) pr.textContent = money(it.final_line_price);
      var ea = row.querySelector('[data-bl-page-each]');
      if (ea) { ea.hidden = it.quantity <= 1; if (it.quantity > 1) ea.textContent = money(it.final_price) + ' each'; }
    });
    var sub = $('[data-bl-page-subtotal]', page); if (sub) sub.textContent = money(cart.total_price);
    var tot = $('[data-bl-page-total]', page); if (tot) tot.textContent = money(cart.total_price);
    var threshold = Number(page.dataset.threshold || 0) * 100;
    if (threshold > 0) {
      var remaining = threshold - cart.total_price;
      var shipRow = $('[data-bl-page-shiprow]', page);
      if (shipRow) shipRow.innerHTML = remaining > 0 ? '<span>Free shipping</span><b>' + money(remaining) + ' away</b>' : '<span>Free shipping</span><b>Unlocked</b>';
      var shipBar = $('[data-bl-page-shipbar]', page);
      if (shipBar) shipBar.style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
      var shipSum = $('[data-bl-page-shipsum]', page);
      if (shipSum) shipSum.textContent = cart.total_price >= threshold ? 'Free' : 'At checkout';
    }
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { alert(res.d.description || 'Sorry, that variant is unavailable.'); return; }
        return fetchCart(true);
      }).catch(function (e) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        console.warn('[belonge] add failed', e);
      });
  }

  function addBundleToCart(idA, idB, btn) {
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: idA, quantity: 1 }, { id: idB, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { alert(res.d.description || 'Sorry, one of those is unavailable.'); return; }
        return fetchCart(true);
      }).catch(function (e) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        console.warn('[belonge] bundle add failed', e);
      });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); updateCartPageDom(cart); return cart; });
  }

  /* ---------- fit finder ---------- */
  var QS = [
    { k: 'Question 01 of 03', t: 'What waist do you measure?', s: 'No tape? Use the jeans size you actually reach for.', o: ['23–25 in', '26–28 in', '29–31 in', '32–34 in', '35 in +'] },
    { k: 'Question 02 of 03', t: 'How do you train most weeks?', s: 'Compression needs change with the movement.', o: ['Lifting', 'Running', 'Yoga & pilates', 'Travel & everyday'] },
    { k: 'Question 03 of 03', t: 'How should it feel?', s: 'There is no wrong answer — we size to the feel you name.', o: ['Locked in', 'Supported, not squeezed', 'Room to breathe'] }
  ];
  var NOTES = {
    'Lifting': 'Sized down half a step — the knit holds through heavy hinging and will not roll at the waist.',
    'Running': 'Kept true to your measurement so the gusset sits flat over long distance.',
    'Yoga & pilates': 'True to measurement with the softer sculpt seam — full depth, zero sheer.',
    'Travel & everyday': 'A touch more give for long sits, still squat-proof when you go straight into a class.'
  };
  var ff = null, step = 0, ans = [];

  function ffRender() {
    if (!ff) return;
    var body = $('[data-bl-ff-body]', ff);
    var bar = $('[data-bl-ff-bar]', ff);
    bar.style.width = (Math.min(step, 3) / 3 * 100) + '%';
    if (step >= 3) {
      var order = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
      var i = ['23–25 in', '26–28 in', '29–31 in', '32–34 in', '35 in +'].indexOf(ans[0]);
      if (i < 0) i = 2;
      if (ans[2] === 'Room to breathe') i = Math.min(i + 1, 5);
      if (ans[2] === 'Locked in' && i > 0) i -= 1;
      var conf = (ans[2] === 'Supported, not squeezed' ? '9 of 10' : '8 of 10') + ' women with your answers kept this size.';
      body.innerHTML = '<div class="bl-res"><div class="bl-res__size"><b>' + order[i] + '</b><div style="padding-bottom:8px">' +
        '<div class="bl-kick">Your size</div><div style="margin-top:6px;font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#7C7669">' + ans.join(' · ') + '</div></div></div>' +
        '<p>' + (NOTES[ans[1]] || 'True to measurement.') + '</p>' +
        '<div class="bl-res__conf">' + conf + '</div>' +
        '<div class="bl-res__cta"><a class="bl-btn bl-btn--light" href="' + (ff.dataset.shopUrl || '/collections/all') + '">Shop this size</a>' +
        '<button class="bl-btn bl-btn--ghost" data-bl-ff-restart>Start over</button></div></div>';
      return;
    }
    var q = QS[step];
    body.innerHTML = '<div class="bl-q"><div style="font-size:10.5px;letter-spacing:.24em;text-transform:uppercase;color:#7C7669">' + q.k + '</div>' +
      '<h3>' + q.t + '</h3><p>' + q.s + '</p><div class="bl-q__opts">' +
      q.o.map(function (o) { return '<button type="button" data-bl-ff-pick="' + o + '"><span>' + o + '</span><i>→</i></button>'; }).join('') +
      '</div>' + (step > 0 ? '<button class="bl-back" data-bl-ff-back>← Back</button>' : '') + '</div>';
  }
  function ffOpen() { if (!ff) return; step = 0; ans = []; ffRender(); ff.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
  function ffClose() { if (!ff) return; ff.removeAttribute('open'); document.body.style.overflow = ''; }

  /* ---------- PDP variant picker ---------- */
  function initPdp(root) {
    var data = JSON.parse($('[data-bl-variants]', root).textContent);
    var optNames = (root.dataset.blOptionNames || '').split('||');
    var colorIdx = -1;
    var sizeIdx = -1;
    optNames.forEach(function (n, i) {
      if (colorIdx < 0 && /colou?r/i.test(n)) colorIdx = i;
      if (sizeIdx < 0 && /size/i.test(n)) sizeIdx = i;
    });
    var mediaEls = $$('[data-bl-media]', root);
    var colorValues = colorIdx > -1
      ? $$('[data-bl-opt-index="' + colorIdx + '"]', root).map(function (b) { return b.dataset.blOpt; })
      : [];

    var owner = new Array(mediaEls.length);
    if (colorIdx > -1 && mediaEls.length) {
      var order = mediaEls.map(function (el) { return String(el.dataset.blMedia); });
      var anchor = {};
      data.forEach(function (v) {
        if (!v.featuredMediaId) return;
        var c = v.options[colorIdx];
        var i = order.indexOf(String(v.featuredMediaId));
        if (i < 0) return;
        if (anchor[c] === undefined || i < anchor[c]) anchor[c] = i;
      });
      var anchors = Object.keys(anchor).map(function (c) { return { c: c, i: anchor[c] }; })
        .sort(function (a, b) { return a.i - b.i; });
      anchors.forEach(function (a, k) {
        var end = k + 1 < anchors.length ? anchors[k + 1].i : mediaEls.length;
        for (var j = a.i; j < end; j++) owner[j] = a.c;
      });
      mediaEls.forEach(function (el, j) {
        var alt = (el.getAttribute('alt') || '').toLowerCase();
        var hits = colorValues.filter(function (c) { return c && alt.indexOf(c.toLowerCase()) > -1; });
        if (hits.length === 1) owner[j] = hits[0];
      });
    }
    var selected = {};
    var idInput = $('[data-bl-variant-id]', root);
    var addBtn = $('[data-bl-add]', root);
    var priceEl = $('[data-bl-price]', root);

    function match() {
      return data.find(function (v) {
        return v.options.every(function (o, i) { return selected[i] === o; });
      });
    }
    function syncMedia() {
      if (colorIdx < 0 || !mediaEls.length) return;
      var val = selected[colorIdx];
      if (!val) return;
      var hasOwn = owner.some(function (o) { return o === val; });
      mediaEls.forEach(function (el, j) {
        var o = owner[j];
        var mine = o === val;
        var generic = o === undefined;
        el.hidden = hasOwn ? !(mine || generic) : false;
        el.style.order = hasOwn ? String(mine ? j - 1000 : generic ? j : j + 1000) : String(j);
      });
      var live = mediaEls.filter(function (el) { return !el.hidden; });
      live.forEach(function (el, i) {
        if (i === 0) { el.setAttribute('fetchpriority', 'high'); el.removeAttribute('loading'); }
      });
    }
    function syncCount() {
      if (colorIdx < 0) return;
      var el = $('[data-bl-optcount="' + colorIdx + '"]', root);
      if (!el) return;
      var val = selected[colorIdx];
      var n = data.filter(function (x) { return x.options[colorIdx] === val && x.available; }).length;
      el.textContent = n ? n + ' available' : 'Sold out';
    }
    function sync() {
      syncMedia();
      syncCount();
      var v = match();
      var complete = Object.keys(selected).length === (data[0] ? data[0].options.length : 0);
      if (v && v.available) {
        idInput.value = v.id;
        addBtn.disabled = false;
        var sz = sizeIdx > -1 && selected[sizeIdx] ? ' \u00b7 Size ' + selected[sizeIdx] : '';
        addBtn.textContent = 'Add to bag' + sz + ' \u00b7 ' + v.priceFormatted;
        if (priceEl) priceEl.innerHTML = '<b>' + v.priceFormatted + '</b>' + (v.compareFormatted ? '<s>' + v.compareFormatted + '</s>' : '');
      } else {
        addBtn.disabled = true;
        addBtn.textContent = !complete ? (sizeIdx > -1 && !selected[sizeIdx] ? 'Select a size' : 'Select your options') : 'Sold out';
      }
    }
    $$('[data-bl-opt]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.dataset.blOptIndex);
        selected[idx] = btn.dataset.blOpt;
        $$('[data-bl-opt-index="' + idx + '"]', root).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        var lbl = $('[data-bl-optlabel="' + idx + '"]', root);
        if (lbl) lbl.textContent = btn.dataset.blOpt;
        sync();
      });
    });
    var first = data.find(function (v) { return v.available; }) || data[0];
    if (first) {
      first.options.forEach(function (o, i) {
        selected[i] = o;
        var b = root.querySelector('[data-bl-opt-index="' + i + '"][data-bl-opt="' + CSS.escape(o) + '"]');
        if (b) b.setAttribute('aria-pressed', 'true');
        var lb = $('[data-bl-optlabel="' + i + '"]', root);
        if (lb) lb.textContent = o;
      });
    }
    sync();
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (idInput.value) addToCart(Number(idInput.value), 1, addBtn);
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var bar = $('[data-bl-offerbar]');
    if (bar) {
      var dismissed = false;
      try { dismissed = sessionStorage.getItem('bl_offerbar_dismissed') === '1'; } catch (e) {}
      if (!dismissed) bar.removeAttribute('hidden');
      var closeBtn = $('[data-bl-offerbar-close]', bar);
      if (closeBtn) closeBtn.addEventListener('click', function () {
        bar.setAttribute('hidden', '');
        try { sessionStorage.setItem('bl_offerbar_dismissed', '1'); } catch (e) {}
      });
    }
    // a page can end up with two overlay renders (section + section-level render); keep the first
    $$('[data-bl-cart]').slice(1).forEach(function (el) { el.parentNode.removeChild(el); });
    $$('[data-bl-ff]').slice(1).forEach(function (el) { el.parentNode.removeChild(el); });
    $$('[data-bl-welcome]').slice(1).forEach(function (el) { el.parentNode.removeChild(el); });
    $$('[data-bl-zoom-overlay]').slice(1).forEach(function (el) { el.parentNode.removeChild(el); });
    drawer = $('[data-bl-cart]');
    ff = $('[data-bl-ff]');
    var welcome = $('[data-bl-welcome]');
    var welcomeTimer = null;
    if (welcome) {
      var seen = false;
      try { seen = localStorage.getItem('bl_welcome_seen') === '1'; } catch (e) {}
      var hasNote = !!welcome.querySelector('.bl-welcome__note');
      if (hasNote) {
        welcome.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        try { localStorage.setItem('bl_welcome_seen', '1'); } catch (e) {}
        setTimeout(function () {
          welcome.removeAttribute('open');
          document.body.style.overflow = '';
        }, 1100);
      } else if (!seen) {
        welcomeTimer = setTimeout(function () {
          welcome.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
          try { localStorage.setItem('bl_welcome_seen', '1'); } catch (e) {}
        }, 2500);
      }
    }
    var welcomeForm = welcome && $('form', welcome);
    if (welcomeForm) {
      welcomeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (welcomeTimer) { clearTimeout(welcomeTimer); welcomeTimer = null; }
        var btn = $('.bl-welcome__submit', welcomeForm);
        btn.disabled = true; btn.textContent = 'Sending\u2026';
        fetch(welcomeForm.action, { method: 'POST', body: new FormData(welcomeForm) })
          .catch(function () {})
          .then(function () {
            welcomeForm.innerHTML = '<p class="bl-welcome__note">Thanks \u2014 your code is on its way.</p>';
            try { localStorage.setItem('bl_welcome_seen', '1'); } catch (e) {}
            setTimeout(function () {
              welcome.removeAttribute('open');
              document.body.style.overflow = '';
            }, 1600);
          });
        return false;
      });
    }
    var pdp = $('[data-bl-pdp]');
    if (pdp) { try { initPdp(pdp); } catch (e) { console.warn('[belonge] pdp init', e); } }
    if (drawer) fetchCart(false);

    function selectCardSwatch(card, sw) {
      $$('[data-bl-cardswatch]', card).forEach(function (el) { el.setAttribute('aria-pressed', String(el === sw)); });
      var media = card.querySelector('.bl-card__media img');
      if (media) {
        media.removeAttribute('srcset');
        media.src = sw.dataset.blCardswatchImg;
        media.dataset.blOrigSrc = sw.dataset.blCardswatchImg;
        media.dataset.blOrigSrcset = '';
      }
      var qa = card.querySelector('[data-bl-quickadd]');
      if (qa && sw.dataset.blCardswatchVariant) {
        qa.dataset.blQuickadd = sw.dataset.blCardswatchVariant;
        qa.textContent = 'Quick add \u00b7 ' + sw.dataset.blCardswatchLabel;
      }
    }
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('[data-bl-cardswatch]');
      if (!sw) return;
      var media = sw.closest('.bl-card').querySelector('.bl-card__media img');
      if (!media) return;
      if (!media.dataset.blOrigSrc) {
        media.dataset.blOrigSrc = media.src;
        media.dataset.blOrigSrcset = media.getAttribute('srcset') || '';
      }
      media.removeAttribute('srcset');
      media.src = sw.dataset.blCardswatchImg;
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest('[data-bl-cardswatch]');
      if (!sw) return;
      if (sw.closest('.bl-card').contains(e.relatedTarget)) return;
      var media = sw.closest('.bl-card').querySelector('.bl-card__media img');
      if (media && media.dataset.blOrigSrc) {
        media.src = media.dataset.blOrigSrc;
        if (media.dataset.blOrigSrcset) media.setAttribute('srcset', media.dataset.blOrigSrcset);
      }
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      var csw = t.closest('[data-bl-cardswatch]');
      if (csw) { e.preventDefault(); selectCardSwatch(csw.closest('.bl-card'), csw); return; }
      var add = t.closest('[data-bl-quickadd]');
      if (add) { e.preventDefault(); addToCart(Number(add.dataset.blQuickadd), 1, add); return; }
      var xadd = t.closest('[data-bl-xsell-add]');
      if (xadd) { e.preventDefault(); addToCart(Number(xadd.dataset.blXsellAdd), 1, xadd); return; }
      var rm = t.closest('[data-bl-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.closest('.bl-line').dataset.key, 0); return; }
      var bundle = t.closest('[data-bl-bundle-add]');
      if (bundle) { e.preventDefault(); addBundleToCart(Number(bundle.dataset.blBundleA), Number(bundle.dataset.blBundleB), bundle); return; }
      var referCopy = t.closest('[data-bl-refer-copy]');
      if (referCopy) {
        var linkEl = document.querySelector('[data-bl-refer-link]');
        if (linkEl && navigator.clipboard) {
          navigator.clipboard.writeText(linkEl.textContent.trim()).then(function () {
            var lbl = referCopy.textContent;
            referCopy.textContent = 'Copied';
            setTimeout(function () { referCopy.textContent = lbl; }, 1500);
          });
        }
        return;
      }
      var zoomTarget = t.closest('[data-bl-zoomable]');
      if (zoomTarget) {
        var zov = $('[data-bl-zoom-overlay]');
        if (zov) {
          var zimg = $('[data-bl-zoom-img]', zov);
          if (zimg) zimg.src = zoomTarget.currentSrc || zoomTarget.src;
          zov.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      var pageQty = t.closest('[data-bl-page-qty]');
      if (pageQty) {
        e.preventDefault();
        var qrow = pageQty.closest('.bl-li');
        var qcur = Number(qrow.querySelector('[data-bl-page-qtyval]').textContent);
        var qnext = Math.max(0, qcur + (pageQty.dataset.dir === 'minus' ? -1 : 1));
        changeLine(qrow.dataset.key, qnext);
        return;
      }
      var pageRm = t.closest('[data-bl-page-remove]');
      if (pageRm) { e.preventDefault(); changeLine(pageRm.closest('.bl-li').dataset.key, 0); return; }
      if (t.closest('[data-bl-opencart]')) { e.preventDefault(); fetchCart(true); return; }
      if (t.closest('[data-bl-close]') || t.closest('[data-bl-scrim]')) { closeDrawer(); ffClose(); var w = $('[data-bl-welcome]'); if (w) { w.removeAttribute('open'); document.body.style.overflow = ''; } var zo = $('[data-bl-zoom-overlay]'); if (zo) zo.removeAttribute('open'); return; }
      if (t.closest('[data-bl-openff]')) { e.preventDefault(); ffOpen(); return; }
      if (t.closest('[data-bl-ff-restart]')) { step = 0; ans = []; ffRender(); return; }
      if (t.closest('[data-bl-ff-back]')) { step = Math.max(0, step - 1); ans = ans.slice(0, step); ffRender(); return; }
      var pick = t.closest('[data-bl-ff-pick]');
      if (pick) { ans[step] = pick.dataset.blFfPick; step += 1; ffRender(); return; }
      var q = t.closest('[data-bl-qty]');
      if (q) {
        var line = q.closest('.bl-line');
        var cur = Number(line.querySelector('.bl-qty span').textContent);
        changeLine(line.dataset.key, Math.max(0, cur + Number(q.dataset.blQty)));
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer(); ffClose();
        var zo = $('[data-bl-zoom-overlay]');
        if (zo) zo.removeAttribute('open');
      }
    });
  });
})();